export default __webpack_public_path__ + "static/media/mooncake-progress-4-4.da6f031f.svg";